import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import PageHero from '../../components/PageHero/PageHero';
import Footer from '../../components/Footer/Footer';
import './OurStory.css';

function OurStory() {
  const ref = useRevealChildren();

  return (
    <>
      <PageHero title="Our Story" />
      <section className="story-section" ref={ref}>
        <div className="container">
          <div className="story-layout">
            <StoryContent />
            <StorySidebar />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

function StoryContent() {
  return (
    <div className="story-content reveal">
      <h2 className="story-heading">The Birth of STUPA</h2>
      <p className="story-text">
        In a world brimming with possibilities, a shared dream brought together a group of passionate
        individuals—visionaries from the non-profit, corporate, and government sectors. United by a
        singular purpose, they set out to build something meaningful—something that would uplift
        communities, empower people, and create lasting change. This dream gave rise to STUPA
        Developmental Foundation, a symbol of resilience, hope, and transformation.
      </p>
      <p className="story-text">
        STUPA was not just born out of ideas but from the lived experiences of its founders—individuals
        who had witnessed firsthand the struggles and aspirations of marginalized communities. They
        recognized that real change requires innovation, inclusivity, and a holistic approach to
        development. The mission was clear: to bring every person—regardless of background—closer to
        a life of dignity, opportunity, and prosperity.
      </p>
      <StoryEmpowerment />
      <StoryJourney />
    </div>
  );
}

function StoryEmpowerment() {
  return (
    <>
      <h3 className="story-subheading reveal">A Foundation for Empowerment</h3>
      <p className="story-text reveal">
        At the heart of STUPA lies a steadfast belief in community empowerment. Rather than offering
        temporary solutions, STUPA fosters sustainable change by equipping people with the tools,
        skills, and opportunities they need to lead independent and fulfilling lives. From improving
        livelihoods to strengthening resilience, every initiative is rooted in the understanding that
        true progress begins when communities take charge of their own destinies.
      </p>
    </>
  );
}

function StoryJourney() {
  return (
    <>
      <h3 className="story-subheading reveal">The Journey Forward</h3>
      <p className="story-text reveal">
        Today, STUPA stands as a bridge between challenges and solutions, blending experience with
        innovation to address the unique needs of people, especially those often overlooked. Be it
        through skilling programs, income enhancement projects, or environmental stewardship, STUPA
        strives to create spaces where individuals can thrive, grow, and rewrite their own stories.
      </p>
      <p className="story-text reveal">
        As we continue this journey, we hold fast to our founding vision: a world where every
        community—no matter how marginalized—has the opportunity to build a better life, step by step,
        together. At STUPA, we don't just dream of change. We work for it.
      </p>
    </>
  );
}

function StorySidebar() {
  return (
    <aside className="story-sidebar reveal reveal-d2">
      <div className="story-sidebar-card">
        <div className="story-sidebar-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
            <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <h4>Founded with Purpose</h4>
        <p>A shared dream of passionate visionaries from non-profit, corporate, and government sectors.</p>
      </div>
      <div className="story-sidebar-card">
        <div className="story-sidebar-icon sage">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <h4>Community First</h4>
        <p>Equipping people with tools, skills, and opportunities for independent, fulfilling lives.</p>
      </div>
    </aside>
  );
}

export default OurStory;
